import api from './client';

export const cartApi = {
  get: () => api.get('/cart'),
  add: (productId, quantity) => api.post('/cart/add', { product_id: productId, quantity }),
  update: (productId, quantity) => api.post('/cart/update', { product_id: productId, quantity }),
  removeItem: (productId) => api.delete(`/cart/item/${productId}`),
  clear: () => api.delete('/cart'),
};
